/* eslint-disable css-modules/no-unused-class, no-extra-boolean-cast */
import { Button, Icon } from 'learning-panel-components';
import { FC } from 'react';
import { translate } from 'translations';
import styles from './lessonBanner.module.scss';

const LessonBanner: FC<LessonBannerProps> = (props: LessonBannerProps) => {
    const { name, description, status, url, iconUrl, earnedPoints, score } = props;

    return (
        <div>
            <div className={styles['lesson-banner']}>
                <div className={styles['inner-wrapper']}>
                    <div className={styles.tag}>{translate(status === 'notStarted' ? 'StartNow' : 'Resume')}</div>
                    <div
                        className={styles[iconUrl ? 'svg-background-opacity' : 'svg-background']}
                        style={{
                            backgroundImage: `url(${
                                iconUrl || `${process.env.PUBLIC_URL}/images/lessonBannerDefaultImage.svg`
                            })`
                        }}
                    ></div>
                    <div className={styles['left-side']}>
                        <div className={styles['top-wrapper']}>
                            <Icon name={'lessonBannerIcon'} className={styles['top-icon']} />
                            <div className={styles.text}>{translate('LESSON')}</div>
                        </div>
                        <div className={styles['name-wrapper']}>
                            <div className={styles.name} title={translate(name)}>
                                {translate(name)}
                            </div>
                        </div>
                        <div className={styles.description} title={translate(description)}>
                            {translate(description)}
                        </div>
                        <div>
                            <div className={styles['button-wrapper']}>
                                <a href={url}>
                                    <Button
                                        type="bigGradient"
                                        text={translate(status === 'notStarted' ? 'TakeLesson' : 'TakeAgain')}
                                        className={styles.button}
                                        lowerCase
                                    />
                                </a>
                                <div className={styles['score-wrapper']}>
                                    {earnedPoints ? (
                                        <div className={styles['earned-points']}>
                                            {translate('Earned')}
                                            <Icon name="devCoin" />
                                            <div className={styles.score}>{earnedPoints}</div>
                                            {score && (
                                                <div className={styles['earned-more-points']}>
                                                    <hr />
                                                    <div>{translate('RetakeToEarnXMore', { x: String(score) })}</div>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div className={styles['earned-points']}>
                                            {translate('TakeToEarnUpTo')}
                                            <Icon name="devCoin" />
                                            <div className={styles.score}>{score}</div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export interface LessonBannerProps {
    name: string;
    description: string;
    url: string;
    iconUrl?: string;
    status: 'completed' | 'notStarted';
    earnedPoints?: number;
    score?: number;
    uuid?: string;
}

export default LessonBanner;
